<template>
  <main v-bind:id="isSwitchedCustom">
    <div class="container pt-6 pb-4"><!-- Início container -->
      <div class="columns"><!-- Início columns -->
        <div class="column is-10 is-offset-1"><!--Início column-->
          <div class="card mt-4 "><!--Início card-->
            <div class="card-content"><!--Início card-content-->
              <div class="container"><!--Início container secundario-->
                <div class="is-flex is-flex-wrap-wrap is-justify-content-center mt-5 mb-6"><!--Início flex-wrap-->
                  <div class="is-relative">
                    <div class="foto">
                      <b-button type="is-danger" @click="removePhoto" v-if="imageData">
                        <b-icon icon="close" />
                      </b-button>
                    </div>
                    <figure class="image ">
                      <img class="img-avatar is-rounded" v-if="imageData" :src="imageData" alt="" />
                      <img v-else class="img-avatar" src="~assets/avatar.png" />
                    </figure>
                  </div>
                  <!--Início formulário-->
                  <b-field label="Foto Pessoal" class=" has-text-centered">
                    <b-upload v-model="avatar" accept="image/png,  image/jpeg" drag-drop>
                      <section class="section">
                        <div class="content has-text-centered">
                          <p>
                            <b-icon icon="upload" size="is-large"> </b-icon>
                          </p>
                          <p>Arraste a foto aqui</p>
                        </div>
                      </section>
                    </b-upload>
                  </b-field>
                </div><!--Fim flex-wrap-->
              </div><!--Fim container secundario-->
              <div class="columns">
                <div class="column">
                  <b-field label="Nome *">
                    <b-input placeholder="Nome" v-model="userData.firstName" required
                      validation-message="Entre com um nome válido" pattern="[A-ZA-z çâêîôûáéíóúàèìòùãẽĩõũ]*"
                      minlength="3" maxlength="255" type="text">
                    </b-input>
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="Sobrenome *">
                    <b-input placeholder="Sobrenome" v-model="userData.lastName" required
                      validation-message="Entre com um sobrenome válido" pattern="[A-ZA-z çâêîôûáéíóúàèìòùãẽĩõũ]*"
                      minlength="3" maxlength="255" type="text">
                    </b-input>
                  </b-field>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <b-field label="CPF *">
                    <b-input disabled v-model="userData.document" type="text" placeholder="CPF"
                      validation-message="Entre com um documento válido" v-mask.raw="['###.###.###-##']">
                    </b-input>
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="Gênero *">
                    <b-select v-model="userData.gender" placeholder="Selecione o gênero" expanded>
                      <option value="M">Masculino</option>
                      <option value="F">Feminino</option>
                      <option value="N">Outro</option>
                    </b-select>
                  </b-field>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <b-field label="Email *">
                    <b-input v-model="userData.email" placeholder="Email" type="email" required>
                    </b-input>
                  </b-field>
                  <b-tag v-if="tagEmail && userData.registerConfirmed === 0" close-type='is-danger' attached closable
                    aria-close-label="Close tag" @close="tagEmail = false">
                    Você ainda não confirmou seu email!
                  </b-tag>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <b-field label="Perfil do Facebook">
                    <b-input v-model="userData.facebookProfile" placeholder="URL" type="url">
                    </b-input>
                  </b-field>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <b-field label="Data de Nascimento" grouped>
                    <b-datepicker ref="datepicker" expanded placeholder="Selecione uma data"
                      v-model="userData.birthdayDate" required>
                    </b-datepicker>
                    <b-button @click="$refs.datepicker.toggle()" icon-left="calendar-today" type="is-primary" />
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="Telefone *">
                    <b-input v-model="userData.phone" placeholder="Fone"
                      validation-message="Entre com um telefone válido" v-mask.raw="['(##) # ####-####']" type="text"
                      required>
                    </b-input>
                  </b-field>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <b-field label="CEP">
                    <b-input v-model="userData.zipcode" placeholder="CEP" validation-message="Entre com um CEP válido"
                      required v-mask="['#####-###']" type="text">
                    </b-input>
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="Bairro">
                    <b-input v-model="userData.neighborhood" maxlength="64" minlength="3" placeholder="Bairro"
                      type="text" required>
                    </b-input>
                  </b-field>
                </div>
              </div>
              <div class="columns">
                <div class="column is-6">
                  <b-field label="Rua">
                    <b-input v-model="userData.street" maxlength="64" minlength="3" placeholder="Rua" type="text"
                      required>
                    </b-input>
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="Número">
                    <b-input maxlength="64" minlength="3" v-model="userData.numberU" placeholder="Número"
                      validation-message="Entre com um número" pattern="[0-9]*" type="text" required>
                    </b-input>
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="Complemento">
                    <b-input v-model="userData.complement" type="text" maxlength="64" minlength="3"
                      placeholder="Complemento" required>
                    </b-input>
                  </b-field>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <b-field label="Estado">
                    <b-select placeholder="Selecione o estado" @input="loadMunicipios" v-model="userData.state" expanded
                      required>
                      <option v-for="estado in estados" :key="estado.id" :value="estado.sigla">{{ estado.nome }}
                      </option>
                    </b-select>
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="Municipio">
                    <b-select placeholder="Selecione o municipio" :disabled="!userData.state" v-model="userData.city"
                      expanded required>
                      <option v-if="!userData.state" value="">Selecione o estado primeiro
                      </option>
                      <option v-else v-for="municipio in municipios" :key="municipio.id" :value="municipio.nome">{{
                        municipio.nome }}
                      </option>
                    </b-select>
                  </b-field>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <b-field label="Senha">
                    <password placeholder="Se quiser manter a mesma senha, deixe este campo vazio" maxlength="60"
                      v-model="passwordTemp" :secureLength="8">
                    </password>
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="Confirmação de senha" required :type="{ 'is-danger': !errors.passwordConfirmed }"
                    :message="{
                      'Senha diferente da inserida anteriormente': !errors.passwordConfirmed,
                    }">
                    <b-input type="password" v-model="passwordConfirm" @input="
                      errors.passwordConfirmed =
                      passwordTemp == passwordConfirm
                      ">
                    </b-input>
                  </b-field>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <div class="buttons is-justify-content-right">
                    <b-button type="is-success" @click="doUpdate">
                      Atualizar
                    </b-button>
                    <b-button v-if="userData.isAdmin == 0" @click="confirmCustomDelete" type="is-danger">
                      Excluir
                    </b-button>
                  </div>
                </div>
              </div>
            </div><!--Fim card-content-->
          </div><!--Fim card-->
        </div><!--Fim column-->
      </div><!--Fim columns-->
    </div><!--Fim container-->
  </main>
</template>

<script>
import { mask } from "vue-the-mask";
import Password from "vue-password-strength-meter";
import { getEstados, getMunicipios } from "../services/ibge";
import { getUser } from "../services/api";
import { editUser } from "../services/api";
import { removeUser } from "../services/api";
import { mapActions } from "vuex";

export default {
  name: "Registro",
  components: { Password },
  directives: {
    mask(el, binding) {
      binding.value ? mask(el, binding) : (el.oninput = null);
    },
  },
  data() {
    return {
      avatar: null,
      tagEmail: true,
      isSwitchedCustom: 'Light',
      imageData: null,
      errors: {
        nome: false,
        sobrenome: false,
        email: false,
        dataNascimento: false,
        telefone: false,
        cep: false,
        bairro: false,
        rua: false,
        numero: false,
        estado: false,
        municipio: false,
        passwordConfirmed: true,
      },
      userData: {},
      passwordConfirm: '',
      estados: [],
      estadoTemp: [],
      passwordTemp: '',
      municipios: [],
      selected: null,
      passwordChanged: false,
      hasEmptyFields: false,
      errorsCount: 0,
    }
  },
  mounted() {
    getEstados().then((resp) => {
      this.estados = resp.data;
    });
    this.loadUser();
  },
  methods: {
    ...mapActions(["logout"]),
    loadUser() {
      return getUser()
        .then((res) => {
          this.userData = res.data;
          if (this.userData.state !== null) {
            this.loadMunicipios();
          }
          if (this.userData.birthdayDate !== null) {
            this.userData.birthdayDate = new Date(this.userData.birthdayDate);
          }
        })
        .catch(() => {
          this.error = true;
        });
    },
    doUpdate() {
      this.isLoading = true;
      const requestData = {
        user_password: this.passwordTemp || null,
        firstName: this.userData.firstName,
        lastName: this.userData.lastName,
        phone: this.userData.phone.replace(/[ +()-]/g, ""),
        email: this.userData.email,
        facebookProfile: this.userData.facebookProfile || null,
        gender: this.userData.gender,
        birthdayDate: this.userData.birthdayDate ?
          this.userData.birthdayDate.toISOString().split("T")[0].replaceAll("/", "-") :
          null,
        street: this.userData.street,
        numberU: this.userData.numberU,
        city: this.userData.city,
        state: this.userData.state,
        zipcode: this.userData.zipcode.replace(/[.-]/g, ""),
        neighborhood: this.userData.neighborhood,
        complement: this.userData.complement || null
      };

      this.validateAndSubmit();

      if (this.errorsCount === 0) {
        editUser(requestData, this.userData.id).then(() => {
          this.isLoading = false;
          this.$router.push("/dashboard");
          this.$buefy.toast.open({
            message: "Perfil atualizado com sucesso!",
            type: "is-success",
          });
        })
          .catch((error) => {
            this.isLoading = false;
            this.formErrors = error.response.data.errors;
            this.$buefy.toast.open({
              message: "Ocorreu um erro ao atualizar o perfil.",
              type: "is-danger",
            });
          })
      }
      else if (this.errorsCount === 1) {
        let campo;
        for (let key in this.errors) {
          if (key !== 'passwordConfirmed' && this.errors[key]) {
            campo = key;
          }
        }

        if(!campo || campo === undefined){
            campo = 'confirmação de senha';
        }
        
        this.$buefy.toast.open({
          message: "Ocorreu um erro ao atualizar o perfil. Campo " + campo + " está incorreto.",
          type: "is-danger",
        });
      }
      else {
        this.$buefy.toast.open({
          message: "Ocorreu um erro ao atualizar o perfil. Existem campos incorretos.",
          type: "is-danger",
        });
      }
    },
    validateAndSubmit() {

      const fieldsMapping = {
        firstName: 'nome',
        lastName: 'sobrenome',
        phone: 'telefone',
        email: 'email',
        birthdayDate: 'dataNascimento',
        street: 'rua',
        numberU: 'numero',
        city: 'municipio',
        state: 'estado',
        zipcode: 'cep',
        neighborhood: 'bairro'
      };

      this.errorsCount = 0;

      if ((this.passwordTemp !== '' && this.passwordConfirm === null) || this.passwordTemp !== this.passwordConfirm) {
        this.errorsCount++;
        this.errors.passwordConfirmed = false;
      }
      for (const [userField, errorField] of Object.entries(fieldsMapping)) {
        if (!this.userData[userField]) {
          if (errorField) {
            this.errors[errorField] = true;
          }
          this.hasEmptyFields = true;
          this.errorsCount++;
        } else {
          if (errorField) {
            this.errors[errorField] = false;
          }
        }
      }

    },
    deleteUser(){
      removeUser(this.userData.id).then(() => {
          this.isLoading = false;
          this.logout();
          this.$router.push("/");
        })
          .catch(() => {
            this.isLoading = false;
            this.logout();
            this.$router.push("/");
            this.$buefy.toast.open({
              message: "Ocorreu um erro ao excluir o perfil.",
              type: "is-danger",
            });
          });   
    },
    removePhoto() {
      if (this.isEdit) {
        if (this.imageData && this.imageData.startsWith("http")) {
          this.avatar = null;
          this.imageData = "";
          this.$buefy.toast.open({
            message: "Foto removida com sucesso!.",
            type: "is-primary",
          });
          this.$buefy.toast.open({
            message: "Ocorreu um erro ao remover a foto.",
            type: "is-danger",
          });
          return Promise.reject();
        } else {
          this.avatar = null;
          this.imageData = "";
          return Promise.resolve;
        }
      } else {
        this.avatar = null;
        this.imageData = "";
        return Promise.resolve();
      }
    },
    loadMunicipios() {
      if (this.userData.state) {
        return getMunicipios(this.userData.state).then(
          (resp) => (this.municipios = resp.data)
        );
      } else return [];
    },
    deleteDropFile() {
      this.avatar = null;
    },
    confirmCustomDelete() {
      this.$buefy.dialog.confirm({
        title: 'Remover sensor',
        message: 'Você tem certeza que deseja <b>deletar</b> sua conta? Essa ação não pode ser desfeita.',
        confirmText: 'Remover',
        cancelText: 'Cancelar',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.deleteUser();
        }
      });
    },
    previewImage: function () {
      if (this.avatar) {
        var reader = new FileReader();
        reader.onload = (e) => {
          this.imageData = e.target.result;
        };
        reader.readAsDataURL(this.avatar);
      }
    },
  },
  watch: {
    avatar(newAvatar) {
      if (newAvatar) {
        this.previewImage();
      }
    },
    computed: {
      selectedString() {
        return this.selected ? this.selected.toDateString() : ''
      },
    },
  },
};

</script>

<style lang="scss" scoped>
.foto {
  position: absolute;
  z-index: 1;
}

.img-avatar {
  max-width: 280px;
}

.mode {
  position: absolute;
  color: #ffffff;
}

#Light .card .card-content {
  background-color: rgb(255, 255, 255);
  color: #000000;
}

#Dark .card {
  background-color: rgb(0, 0, 0);
  color: #ffffff;
}

#Dark .card .card-content b-field .label {
  color: #ffffff;
}

@include tablet {
  .img-avatar {
    margin-right: 3rem;
  }
}

@include desktop {
  .img-avatar {
    margin-right: 3rem;
  }
}

main {
  background: url("../assets/capa.png"), url("../assets/ruido.png"),
    linear-gradient(110deg, $primary, #7c26f8);
  background-attachment: fixed;
}
</style>